// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6585) return "static/chunks/6585-e5ca4b000445b479.js";
	if (chunkId === 6933) return "static/chunks/0f987275-1cde77b80acada94.js";
	if (chunkId === 7115) return "static/chunks/7105534e-a0f693e1cb91323d.js";
	if (chunkId === 2637) return "static/chunks/2637-d559baee2cce7aa7.js";
	if (chunkId === 3720) return "static/chunks/3720-75e0aae250d2db4a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3119 ? "717a1995" : chunkId) + "." + {"620":"83867518a775b689","3119":"89869f7a775ffe6e","3532":"942f6e0c7486c337","4032":"fc638d2f9893f6f4","4535":"528f539e7c3a0a20","5826":"685ceb72fea81b95","6434":"abbd83c1d7161c11"}[chunkId] + ".js";
};